const authPath = '/authentication'

export const paths = {
  applications: '/applications',
  dashboard: '/dashboard',
  teamDetails: (teamId: string) => `/people/teams/${teamId}`,
  profile: { root: '/profile', trustedDevices: '/profile/trusted-devices' },
  theme: '/theme',
  auth: {
    login: `${authPath}/login`,
    resetPassword: `${authPath}/reset-password`,
    resetPasswordConfirm: `${authPath}/reset-password-confirm`,
    invitation: `${authPath}/invitation`,
    brokerConfirmInvitation: `${authPath}/broker/confirm-invite`,
    otpConfirm: `${authPath}/otp-confirm`,
    backUpConfirm: `${authPath}/backup-confirm`
  },
  people: (tab: string) => `/people/${tab}`,
  users: {
    root: '/people/users',
    add: '/people/users/add',
    invite: '/people/users/invite',
    details: (userId?: string) => `/people/users/${userId}`,
    permissions: (userId?: string) => `/people/users/${userId}/permissions`
  },
  teams: {
    root: '/people/teams',
    add: '/people/teams/add',
    details: (teamId?: string) => `/people/teams/${teamId}`
  },
  roles: {
    root: '/people/roles'
  },
  logs: {
    root: '/logs',
    applications: '/logs/applications',
    mfa: '/logs/mfa'
  },
  notifications: {
    root: '/notifications',
    details: (id: string | number) => `/notifications/${id}`
  },
  configsMFAPage: {
    root: '/configs-mfa'
  },
  partners: {
    root: '/staff/partners',
    companiesManagement: '/staff/partners/companies-management',
    agents: (brokerId?: string | number) =>
      `/staff/partners/agents/${brokerId}`,
    teams: (brokerId?: string | number) => `/staff/partners/teams/${brokerId}`,
    media: (brokerId?: string | number) => `/staff/partners/media/${brokerId}`
  },
  lockouts: {
    root: '/lockouts'
  }
}
